import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './MyLibrary.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { usePage } from '../../hooks/usePage';

import { libApiSlice } from '../../services/library';
import { menuChanged, selectMenu } from '../../features/infoSlice';
import {
  libEditModeToggled,
  selectLibOptions,
} from '../../features/librarySlice';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';
import ListOption from '../../components/ListOption';
import List from '../../components/List';
import Details from '../../components/Details';
import { LIBRARY, LIST } from '../../constants';
import { useSetUploaderTypeMutation } from '../../services/common';

export default function MyLibrary() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const { isDetailsOpened, isEditMode } = useAppSelector(selectLibOptions);
  const { pageChanged } = usePage();
  const [setUploaderType] = useSetUploaderTypeMutation();

  const getTid = async () => {
    try {
      const data = await setUploaderType(1).unwrap();
    } catch (error) {
      console.error('Failed to get Tid', error);
    }
  };

  useEffect(() => {
    dispatch(menuChanged('library'));
    menu === 'library' && dispatch(pageChanged(0));
    dispatch(libEditModeToggled(false));
    getTid();
  }, []);

  if (menu !== 'library') return null;

  return (
    <Container isSubPage={true}>
      <TopArea title={LIBRARY} className="st_subpage" />
      <div className={cx('content')}>
        <div className={cx('section')}>
          <h2 className="blind">
            {LIBRARY} {LIST}
          </h2>
          <ListOption />
          <div
            className={cx(
              'library_area',
              {
                'library--info-active': isDetailsOpened,
              },
              {
                'is--editing': isEditMode,
              }
            )}
          >
            <List />
            {isDetailsOpened && <Details />}
          </div>
        </div>
      </div>
    </Container>
  );
}
